import React, { useState, useEffect } from "react";
import styles from "./myTradeLimitMobile.module.css";
import HeadLines from "../../../../CommonComponents/HeadLines";
import MultiProgressbar from "../MultiProgressBar/MultiProgressBar";
import { getMyTradeList } from "../../../../../../../_services/Arya2.0/Homepage";
import { customToastr } from "../../../../CustomToastr";
import FlexComponentMobile from "../FlexComponentMobile/FlexComponentMobile";
import { isMobile } from "../../../../helperFunc";

const MyTradeLimitMobile = () => {
  const [data, setData] = useState(null);

  const getTradeData = async () => {
    try {
      const response = await getMyTradeList();
      if (response?.status_code === 200 && response?.data) {
        setData(response?.data);
      } else {
        customToastr({
          type: "warning",
          timeOut: 3000,
          text: response?.message,
        });
      }
    } catch (error) {
      customToastr({
        type: "error",
        timeOut: 3000,
        text: error?.message,
      });
    }
  };

  useEffect(() => {
    getTradeData();
  }, []);

  return (
    <>
      {data?.totalLimit > 0 && (
        <>
          <FlexComponentMobile leftTitle="My Trade Limit" />

          <div className={styles.mobtradeLimitContainer}>
            {/* Total Limit Section */}
            <div className={styles["w-47"]}>
              <div className={styles.limitCard}>
                <div>
                  <HeadLines
                    text="Total Limit"
                    className="font-weight400 font-size12 line-height14 grayDark"
                  />
                  <HeadLines
                    className={`font-weight700 font-size18 line-height21 ${styles.limitHeader}`}
                    text={`₹ ${parseFloat(data.totalLimit).toLocaleString(
                      "en-IN",
                      {
                        maximumFractionDigits: 2,
                      }
                    )}`}
                  />
                </div>
                <MultiProgressbar
                  totalLimit={data.totalLimit}
                  stpLimit={data.stpTotalLimit}
                  ltpLimit={data.ltpTotalLimit}
                />
                <div className={styles.limitFooter}>
                  <div className={`${styles["stpLimit"]} `}>
                    <HeadLines
                      text="STP Limit"
                      className={`font-size10 line-height12 font-weight400 colorAccent3`}
                    />
                    <HeadLines
                      text={`₹${parseFloat(data.stpTotalLimit).toLocaleString(
                        "en-IN",
                        {
                          maximumFractionDigits: 2,
                        }
                      )}`}
                      className={`font-size12 line-height15 font-weight500 colorAccent3 ${styles["truncate"]}`}
                    />
                  </div>
                  <div className={styles.ltpLimit}>
                    <HeadLines
                      text="LTP Limit"
                      className={`font-size10 line-height12 font-weight400 colorAccent3`}
                    />
                    <HeadLines
                      text={`₹ ${data.ltpTotalLimit.toLocaleString()}`}
                      className={`font-size12 line-height15 font-weight500 colorAccent3 ${styles["truncate"]}`}
                    />
                  </div>
                </div>
              </div>
            </div>

            {isMobile && <div className={styles["divider"]} />}

            {/* Utilized Limit Section */}
            <div className={styles["w-47"]}>
              <div className={styles.limitCard}>
                <div>
                  <HeadLines
                    text="Utilized Limit"
                    className="font-weight400 font-size12 line-height14 grayDark"
                  />
                  <HeadLines
                    className={`font-weight700 font-size18 line-height21 ${styles.limitHeader}`}
                    text={`₹ ${data.utilizedLimit.toLocaleString()}`}
                  />
                </div>
                <MultiProgressbar
                  totalLimit={data.utilizedLimit}
                  stpLimit={data.stpUtilizedLimit}
                  ltpLimit={data.ltpUtilizedLimit}
                />
                <div className={styles.limitFooter}>
                  <div className={styles.stpLimit}>
                    <HeadLines
                      text="STP Utilized"
                      className={`font-size10 line-height12 font-weight400 colorAccent3 white-space-noWrap`}
                    />
                    <HeadLines
                      text={`₹ ${data.stpUtilizedLimit.toLocaleString()}`}
                      className={`font-size12 line-height15 font-weight500 colorAccent3 ${styles["truncate"]}`}
                    />
                  </div>
                  <div className={styles.ltpLimit}>
                    <HeadLines
                      text="LTP Utilized"
                      className={`font-size10 line-height12 font-weight400 colorAccent3 white-space-noWrap`}
                    />
                    <HeadLines
                      text={`₹${data.ltpUtilizedLimit.toLocaleString()}`}
                      className={`font-size12 line-height15 font-weight500 colorAccent3 ${styles["truncate"]}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MyTradeLimitMobile;
